<template>
  <RevContainer>
    <h2 class="text-static-default-hi heading-1 mb-4 flex md:justify-center">
      {{ i18n(translations.title) }}
    </h2>

    <PoliciesAndEligibleInsurances
      v-if="policies && !isEmpty(policies)"
      :eligible-insurances
      :policies
    />

    <EligibleInsurances
      v-if="isEmpty(policies) && !isEmpty(eligibleInsurances)"
      :eligible-insurances
    />
  </RevContainer>
</template>

<script setup lang="ts">
import { useAsyncData } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { isEmpty } from '@ds/utils/isEmpty'

import translations from './ServicesHub.translations'
import EligibleInsurances from './pages/EligibleInsurances/EligibleInsurances.vue'
import PoliciesAndEligibleInsurances from './pages/PoliciesAndEligibleInsurances/PoliciesAndEligibleInsurances.vue'
import type { EligibleInsurance } from './types'

const i18n = useI18n()
const $httpFetch = useHttpFetch()

const { data: policies } = await useAsyncData(() => {
  return $httpFetch('/api/insurance/v1/services-hub/policies', {
    method: 'GET',
  })
})

// TODO Fetch policies
const eligibleInsurances: EligibleInsurance[] = []
</script>
